import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

/**
 * Client Supabase (clé publishable/anon — lecture seule via RLS).
 * null si non configuré → le dashboard retombe sur la simulation mock.
 */
export const supabase: SupabaseClient | null =
  url && anon ? createClient(url, anon) : null;

export const SUPABASE_READY = Boolean(supabase);
